import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { Icon } from '@livable/saas-react-components';
import { useTranslation } from 'react-i18next';
import { Alert, Button, InputAdornment, TextField, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import useStyles from './styles';
export const ListItem = observer(_ref => {
  let item = _ref.item,
    isDisabled = _ref.isDisabled;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const isActive = item.isActive;
  // const isError = item.isError && item.customMode;
  const isError = item.isError;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpenDetails = _useState2[0],
    setIsOpenDetails = _useState2[1];
  const _useState3 = useState(item.value),
    _useState4 = _slicedToArray(_useState3, 2),
    itemInitValue = _useState4[0],
    setItemInitValue = _useState4[1];
  const getClass = () => {
    let classList = "".concat(classes.listItem);
    if (isActive) classList += " ".concat(classes.listItemActive);
    if (isError) classList += " ".concat(classes.listItemError);
    return classList;
  };
  return /*#__PURE__*/React.createElement("div", {
    key: "LIST_ITEM_".concat(item.id),
    id: "LIST_ITEM_".concat(item.id, "_ID"),
    className: getClass()
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.listItemContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.listItemText
  }, item.iconType && /*#__PURE__*/React.createElement("span", {
    className: classes.listItemTextIcon
  }, /*#__PURE__*/React.createElement(Icon, {
    type: item.iconType
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: isDisabled ? 'light' : ''
  }, item.title, ":"), !item.isEditable && !(item !== null && item !== void 0 && item.isGWD) && /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "light"
  }, /*#__PURE__*/React.createElement("span", {
    className: item.warningValue ? classes.warningValue : ''
  }, "\xA0", item.value, "\xA0"), item.isDefault ? t('add_new_property_flow.default') : ''), item.isEditable && !(item !== null && item !== void 0 && item.isGWD) && !isOpenDetails && /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "light"
  }, /*#__PURE__*/React.createElement("span", {
    className: item.warningValue ? classes.warningValue : ''
  }, "\xA0Notify when changes by\xA0", /*#__PURE__*/React.createElement("b", null, item.value), "\xA0"), item.isDefault ? t('add_new_property_flow.default') : ''), (item === null || item === void 0 ? void 0 : item.isGWD) && !isOpenDetails && /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "light"
  }, /*#__PURE__*/React.createElement("span", {
    className: item.warningValue ? classes.warningValue : ''
  }, "\xA0", item.value, "%\xA0"), item.isDefault ? t('add_new_property_flow.default') : ''))), !item.isEditable && /*#__PURE__*/React.createElement("div", {
    className: classes.action
  }, item.action), !item.isEditable && item.showInfo && /*#__PURE__*/React.createElement("div", {
    className: classes.action
  }, item.infoComponent), item.isEditable && /*#__PURE__*/React.createElement("div", {
    className: classes.action
  }, isOpenDetails && /*#__PURE__*/React.createElement("div", {
    className: classes.editableForm
  }, !(item !== null && item !== void 0 && item.isGWD) && /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "light"
  }, "Notify when changes by:"), /*#__PURE__*/React.createElement(TextField, {
    variant: "outlined",
    fullWidth: true,
    size: "small",
    value: item.value,
    error: (item === null || item === void 0 ? void 0 : item.isGWD) && +(item === null || item === void 0 ? void 0 : item.utilityCAD) + +item.value > 100,
    InputProps: {
      endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end"
      }, "%")
    },
    onKeyPress: event => {
      if (!/[0-9]|[.,]/.test(event.key)) {
        event.preventDefault();
      }
    },
    onChange: e => {
      if (!/^\d+([.,]\d{0,2})?$|^$/.test(e.target.value) || !(item !== null && item !== void 0 && item.isGWD && Number(e.target.value) <= 100)) return;
      item.onChangeCallback(e.target.value);
    }
  })), !isOpenDetails && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    onClick: () => {
      // Take the value as it is now, not as it was when this item mounted.
      setItemInitValue(item.value);
      setIsOpenDetails(true);
    },
    'custom-attribute': '641-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Edit"))))), isOpenDetails && (item === null || item === void 0 ? void 0 : item.isGWD) && +(item === null || item === void 0 ? void 0 : item.utilityCAD) + +item.value > 100 && /*#__PURE__*/React.createElement("div", {
    className: classes.listItemAlerts
  }, /*#__PURE__*/React.createElement(Alert, {
    severity: "error",
    icon: false,
    size: "small"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, "The total of CAD and GWD cannot exceed 100%. We recommend the maximum allowable value for GWD is", ' ', 100 - +(item === null || item === void 0 ? void 0 : item.utilityCAD), "%. Please adjust your input."))), isOpenDetails && (item === null || item === void 0 ? void 0 : item.isGWD) && +(item === null || item === void 0 ? void 0 : item.utilityCAD) + +item.value === 0 && /*#__PURE__*/React.createElement("div", {
    className: classes.listItemAlerts
  }, /*#__PURE__*/React.createElement(Alert, {
    severity: "warning",
    icon: false,
    size: "small"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, "Both CAD and GWD cannot be zero.", /*#__PURE__*/React.createElement("br", null), "We recommend to assign a positive value to at least one of them."))), item.isEditable && isOpenDetails && /*#__PURE__*/React.createElement("div", {
    className: classes.listItemDetails
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    size: "small",
    onClick: () => {
      item.onChangeCallback(itemInitValue);
      setIsOpenDetails(false);
    },
    'custom-attribute': '642-new-billing-module'
  }, "Discard changes"), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    size: "small",
    disabled: (item === null || item === void 0 ? void 0 : item.isGWD) && +(item === null || item === void 0 ? void 0 : item.utilityCAD) + +item.value > 100,
    onClick: () => {
      setItemInitValue(item.value);
      item.submitCallback();
      setIsOpenDetails(false);
    },
    'custom-attribute': '643-new-billing-module'
  }, "Save changes")));
});